import React, { useState } from 'react';
import { Box, Typography, List, ListItem, Paper, TextField, IconButton, Snackbar, ListItemIcon, ListItemText } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const SubmittedDocuments = ({ documents }) => {
  const [openSnackbar, setOpenSnackbar] = useState(false);

  if (!documents || documents.length === 0) {
    return null;
  }

  const handleCopyLink = (link) => {
    navigator.clipboard.writeText(link);
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <Paper variant="outlined" sx={{ mt: 4, p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Recently Submitted Documents
      </Typography>   
      <List>
        {documents.map((doc, index) => (
          <ListItem key={index} divider={index !== documents.length - 1}>
            {doc.downloadLink && (
              <ListItemIcon>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <TextField
                    size="small"
                    value={doc.downloadLink}
                    fullWidth
                    readOnly
                  />
                  <IconButton 
                    size="small" 
                    onClick={() => handleCopyLink(doc.downloadLink)}
                    title="Copy link"
                    sx={{ mr:2}}
                  >
                    <ContentCopyIcon fontSize="small" />
                  </IconButton>
                </Box>
              </ListItemIcon>
            )}
            <ListItemText
              primary={`DOCID: ${doc.docId}`}
              secondary={doc.Title1}
              sx={{
                '& .MuiListItemText-secondary': {
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }
              }}
            />
          </ListItem>
        ))}
      </List>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={1000}
        onClose={handleCloseSnackbar}
        message="Link copied to clipboard"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </Paper>
  );
};

export default SubmittedDocuments; 